import { Toast, ToastVariant } from "@kamae-apps/shared/Components/Molecules/Toast/Toast"
import React, { useEffect, useState } from "react"

export interface ToastInterface {
  addToast: (toast: ToastOptions) => void
}

export interface ToastOptions {
  color: ToastVariant
  children: any
  timeout: number
}

export const ToastColor: Record<string, ToastVariant> = {
  success: "toast-success",
  danger: "toast-error",
  warning: "toast-warning",
}

interface ToastContainerState {
  toasts: Map<number, JSX.Element>
}

type ToastWrapperProps = {
  toast: ToastOptions
  onClose: () => void
}

const ToastWrapper: React.FC<ToastWrapperProps> = ({ toast, onClose }) => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 5000)

    return () => clearTimeout(timer)
  }, [onClose])

  if (!isVisible) return null

  return (
    <Toast
      variant={toast.color}
      message={toast.children}
      //TODO Gérer le bouton close du Toast
      closeButton={false}
      onClickLink={() => {
        setIsVisible(false)
      }}
    />
  )
}

//Container of Toast to add to the page to use Toast
export class ToastContainer extends React.Component<{}, ToastContainerState> {
  constructor(props: {}) {
    super(props)
    this.state = {
      toasts: new Map<number, JSX.Element>(),
    }
    this.deleteToast = this.deleteToast.bind(this)
    this.addToast = this.addToast.bind(this)
  }

  deleteToast(id: number) {
    this.state.toasts.delete(id)
    this.setState({ toasts: this.state.toasts })
  }

  async addToast(toast: ToastOptions) {
    let max = -1
    this.state.toasts.forEach((value, key) => {
      if (key > max) {
        max = key
      }
    })
    const newKey = max + 1
    this.state.toasts.set(newKey, this.makeToast(toast, newKey))
    this.setState({ toasts: this.state.toasts })
  }

  makeToast(value: ToastOptions, index: number) {
    return (
      <ToastWrapper
        key={index}
        toast={value}
        onClose={() => this.deleteToast(index)}
      />
    )
  }

  render() {
    let t: JSX.Element[] = []
    this.state.toasts.forEach((value, key) => {
      t.push(value)
    })
    return <div className="fixed right-0 bottom-0 z-[1000] flex flex-col">{t}</div>
  }
}
